import analytics from './analytics';

type ReadyArgs = Parameters<SegmentAnalytics.AnalyticsJS['ready']>;

function ready(...args: ReadyArgs) {
  return analytics().ready(...args);
}

export default ready;
